import React, { forwardRef, useContext } from 'react';
import ImageGallery, {ReactImageGalleryItem} from 'react-image-gallery';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Controls from './Controls';
import { CarouselContext } from './CarouselContext';
import { Loading } from 'components/Loading';

const FullScreenCarousel = forwardRef<ImageGallery>((props, ref) => {
    const {
        startDrag,
        onDrag,
        endDrag,
        imgTransform,
        isDragging,
        galleryImages,
        handleSlideChange,
        currentIndex,
        imageRefs,
        isFullScreen: show,
        setIsFullScreen,
        loading,
    } = useContext(CarouselContext);

    const renderItem = (item: ReactImageGalleryItem) => {
        const i = galleryImages.indexOf(item);

        return (
            <div
                ref={(el: HTMLDivElement | null) => {
                    if (el) imageRefs.current[i] = el;
                }}
                onMouseDown={startDrag}
                onMouseMove={onDrag}
                onMouseUp={endDrag}
                onMouseLeave={endDrag}
                className="image-gallery-container-fs"
            >
                <img
                    src={item.original}
                    alt={item?.originalAlt || item.original}
                    style={{
                        transform: `scale(${imgTransform[i].zoom}) translate(${imgTransform[i].x}px, ${imgTransform[i].y}px)`,
                        cursor: isDragging ? 'grabbing' : 'grab',
                    }}
                />
            </div>
        );
    };

    return (
        <Modal
            size="lg"
            show={show}
            onHide={() => setIsFullScreen(false)}
            className={`full-page-modal ${loading ? 'full-page-modal-loading' : ''}`}
        >
            {loading && <Loading />}
            <FontAwesomeIcon
                icon={faTimes}
                className="fa-3x close-x full-screen-close"
                onClick={() => setIsFullScreen(false)}
            />
            {!loading && (
                <>
                    <ImageGallery
                        startIndex={currentIndex || 0}
                        items={galleryImages}
                        showFullscreenButton={false}
                        showPlayButton={false}
                        ref={ref}
                        onSlide={handleSlideChange}
                        renderItem={renderItem}
                        renderLeftNav={() => null}
                        renderRightNav={() => null}
                    />
                    <Controls />
                </>
            )}
        </Modal>
    );
});

export default FullScreenCarousel;